import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Link } from 'react-router';
import { I18N } from '../../../../constants';

const recoveryActionLinkFormatter = (cell, row) => {
    if (row.genericAbnormalityType === 'MANIFEST_BASED') {
        return (
            <Link
                to={`/manifests/${row.manifestNavigation.manifestId}/abnormality/${
                    row.abnormalityType
                }/${row.abnormalityId}/recoveryAction/${row.recoveryActionType}/${
                    row.recoveryActionId
                }`}
            >
                {row.name}
            </Link>
        );
    }
    return (
        <Link
            to={`/runs/${row.runId}/abnormality/${row.abnormalityType}/${
                row.abnormalityId
            }/recoveryAction/${row.recoveryActionType}/${row.recoveryActionId}`}
        >
            {row.name}
        </Link>
    );
};

const RecoveryActionsListSimple = ({ recoveryActions }) => (
    <BootstrapTable data={recoveryActions} hover>
        <TableHeaderColumn dataField="recoveryActionId" isKey hidden>
            ID
        </TableHeaderColumn>
        <TableHeaderColumn dataField="name" dataFormat={recoveryActionLinkFormatter}>
            Name
        </TableHeaderColumn>
        <TableHeaderColumn
            dataField="recoveryActionType"
            dataFormat={type => I18N.RECOVERY_ACTIONS[type]}
        >
            Type
        </TableHeaderColumn>
        <TableHeaderColumn
            dataField="status"
            width="150"
            dataFormat={status => I18N.RECOVERY_ACTION_STATUS[status]}
        >
            Status
        </TableHeaderColumn>
    </BootstrapTable>
);

export default RecoveryActionsListSimple;
